var detectBrowser = require('./lib/detectBrowser');

var agent;

if (typeof navigator !== 'undefined' && navigator) {
  agent = navigator.userAgent;
}

module.exports = detectBrowser(agent);



//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/detect-browser/browser.js
// module id = 289
// module chunks = 0